import { ProductUnit } from '@coworkrz/products/types';
import { Type } from 'class-transformer';
import {
  ArrayNotEmpty,
  IsArray,
  IsNotEmpty,
  IsUUID,
  IsPositive,
  ValidateNested,
  IsEnum,
} from 'class-validator';

export class CartItemDto {
  @IsNotEmpty()
  @IsUUID()
  product!: string;

  @IsNotEmpty()
  @IsPositive()
  quantity!: number;

  @IsEnum(ProductUnit)
  priceUnit!: ProductUnit;
}

export class AddItemsDto {
  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  @Type(() => CartItemDto)
  cartItems!: CartItemDto[];

  @IsNotEmpty()
  cardNumber!: string;
}
